// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketplaceV3FaqSection_container__fAsPI","title":"MarketplaceV3FaqSection_title__fhyoV"};